import Product from '@vue-storefront/core/modules/catalog/types/Product'
import { WishlistModule } from '../'
import { registerModule } from '@vue-storefront/core/lib/modules';

export const RemoveFromWishlist = {
  name: 'RemoveFromWishlist',
  props: {
    product: {
      required: true,
      type: Object
    }
  },
  methods: {
    removeFromWishlist (product: Product) {
      registerModule(WishlistModule)
      this.$store.dispatch('wishlist/removeItem', product)
    }
  }
}
